export const resizeImageToSquare = async (
	file: File,
	targetSize: number,
): Promise<Blob> => {
	const img = new Image()
	img.src = URL.createObjectURL(file)

	await new Promise<void>((resolve, reject) => {
		img.onload = () => resolve()
		img.onerror = () => reject(new Error('Failed to load image'))
	})

	const { width, height } = img

	// Determine crop bounds for square center crop
	const side = Math.min(width, height)
	const sx = Math.floor((width - side) / 2)
	const sy = Math.floor((height - side) / 2)

	// Draw square crop and resize
	const canvas = document.createElement('canvas')
	canvas.width = targetSize
	canvas.height = targetSize
	const ctx = canvas.getContext('2d')
	if (!ctx) throw new Error('Canvas context not available')

	ctx.drawImage(img, sx, sy, side, side, 0, 0, targetSize, targetSize)

	return await new Promise((resolve, reject) => {
		canvas.toBlob((blob) => {
			if (blob) resolve(blob)
			else reject(new Error('Failed to convert canvas to blob'))
		}, 'image/png')
	})
}
